import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Center,
  Flex, // Import Flex here
  useColorModeValue,
} from '@chakra-ui/react';

interface ErrorProps {
  errorMessage: string;
  title?: string;
  suggestion?: string;
}

export const Error: React.FC<ErrorProps> = ({
  errorMessage,
  title = "Access Denied or Error",
  suggestion = "Please ensure you have the correct permissions or try again.",
}) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const alertBg = useColorModeValue('red.50', 'red.900');
  const alertTextColor = useColorModeValue('red.700', 'red.200');

  return (
    <Flex
      minH={'100%'} // Use 100% to fill the parent container's height
      bg={useColorModeValue('gray.100', 'gray.900')}
      justifyContent="center" // Centers content horizontally
      alignItems="center" // Centers content vertically
    >
      <Box
        p={{ base: 6, md: 8 }}
        maxWidth={{ base: '90%', md: '600px' }}
        w={'full'}
        bg={cardBg}
        boxShadow={'lg'}
        rounded={'lg'}
        textAlign="center"
        color={textColor}
      >
        <Alert
          status="error"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="200px"
          borderRadius="lg"
          bg={alertBg}
          color={alertTextColor}
        >
          <AlertIcon boxSize="60px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            {title}
          </AlertTitle>
          <AlertDescription whiteSpace="wrap" wordBreak="break-word">
            {errorMessage}
            <br />
            {suggestion}
          </AlertDescription>
        </Alert>
      </Box>
    </Flex>
  );
};